import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StoreNavigationHeader } from '../../../Types/StoreTypes';

const initialState: StoreNavigationHeader = {
    navigationTitle: '',
    navigationSubTitle: '',
    isMobileMenuOpen: false,
    navigationImage: '',
};

const navigationHeaderSlice = createSlice({
    name: 'navigationHeader',
    initialState,
    reducers: {
        setNavigationTitle: (state, action: PayloadAction<StoreNavigationHeader['navigationTitle']>) => {
            state.navigationTitle = action.payload;
        },
        setNavigationSubTitle: (state, action: PayloadAction<StoreNavigationHeader['navigationSubTitle']>) => {
            state.navigationSubTitle = action.payload;
        },
        setNavigationImage: (state, action: PayloadAction<StoreNavigationHeader['navigationImage']>) => {
            state.navigationImage = action.payload;
        },
        setMobileMenuOpen: (state, action: PayloadAction<StoreNavigationHeader['isMobileMenuOpen']>) => {
            state.isMobileMenuOpen = action.payload;
        },
    },
});

export const { setNavigationTitle, setNavigationSubTitle, setNavigationImage, setMobileMenuOpen } =
    navigationHeaderSlice.actions;

export default navigationHeaderSlice.reducer;
